// extracted by mini-css-extract-plugin
export var blockWrap = "schema-viewer-module--block-wrap--2ff98";
export var dark = "schema-viewer-module--dark--4b9e4";
export var required = "schema-viewer-module--required--5dd79";
export var schema = "schema-viewer-module--schema--4add6";
export var schemaBlock = "schema-viewer-module--schema-block--96f3f";
export var schemaDetailsBtn = "schema-viewer-module--schema-details-btn--f4277";
export var title = "schema-viewer-module--title--32060";